module.exports = {
  random: require('./random'),
  roundRobin: require('./round_robin')
};



//////////////////
// WEBPACK FOOTER
// ./~/elasticsearch/src/lib/selectors/index.js
// module id = kiSU
// module chunks = 0